import { FC, Fragment, useMemo } from "react";
import { PaginationItemType, PaginationProps } from "../../pagination.types";
import styles from "./pagination-1.module.css";
import { NavLink } from "@remix-run/react";
import { AppLink } from "@commons-monorepo/index";
import { UiButton } from "~/components/ui-button";
import { organizerItems } from "./pagination-1.utils";
import { usePagination } from "../../pagination.hook";

const ItemButton = ({
  numberPage,
  active



}: {numberPage: number;active: boolean;}) =>
<UiButton
  isFilled
  isBlack={!active}
  className={!active ? styles.btnBlackPagination : ""}
  size='short'>

    {numberPage}
  </UiButton>;


const Pagination1: FC<PaginationProps> = ({
  pages,
  page = 1,
  isMobile = true,
  className
}) => {
  const {
    t,
    prevLink,
    nextLink,
    isActive,
    createUrlWithPagination,
    launchChangePageEvent
  } = usePagination({
    pages,
    page,
    isMobile
  });

  const items = useMemo(() => {
    return (Array.from({ length: pages }, (_, i) => i + 1).map((itemPage) => {
      return { page: itemPage, link: createUrlWithPagination(itemPage) };
    }) as PaginationItemType[]);
  }, [pages, page, isMobile, createUrlWithPagination]);

  const itemFilters = useMemo(
    () => organizerItems(items, page, isMobile),
    [items, page, isMobile]
  );

  return pages > 1 ?
  <div className={`${styles.pagination1} ${className || ""}`}>
      {page !== 1 &&
    <AppLink
      to={prevLink}
      className={`${styles.itemButton} ${styles.link} ${styles.linkPrev}`}
      Component={NavLink}
      onClick={() => launchChangePageEvent("previous")}>

          <span className='icon-arrow-right' />
          <span>{t("pagination.prev")}</span>
        </AppLink>}

      {itemFilters.map((item, index) =>
    <Fragment key={`pagination-item-${index}`}>
          {item.page && !isActive(item.page) ?
      <AppLink
        to={item.link}
        Component={NavLink}
        onClick={() => launchChangePageEvent(String(item.page))}>

              <ItemButton numberPage={item.page} active={false} />
            </AppLink> :

      <>
              {item.page ?
        <ItemButton numberPage={item.page} active={true} /> :

        <UiButton className={styles.itemButtonText} size='short'>
                  {item.text}
                </UiButton>}

            </>}

        </Fragment>
    )}
      {page !== pages &&
    <AppLink
      to={nextLink}
      className={`${styles.itemButton} ${styles.link} ${styles.linkNext}`}
      Component={NavLink}
      onClick={() => launchChangePageEvent("next")}>

          <span>{t("pagination.next")}</span>
          <span className='icon-arrow-right' />
        </AppLink>}

    </div> :
  null;
};

export default Pagination1;